import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { lazy, Suspense, useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import useTheme from "./hooks/useTheme";
import { light as lightTheme } from "./themes/light.js";
import AOS from "aos";
import "aos/dist/aos.css";

import { Box } from "@mui/material";
import Footer from "./components/Footer";
import Header from "./components/Header";
import LoadingSplash from "./components/LoadingSplash";
import Messages from "./components/Messages/Messages";
import { cssTransition, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";

import "@rainbow-me/rainbowkit/styles.css";

AOS.init();

const DEBUG = false;
const Home = lazy(() => import("./views/home"));
if (DEBUG) console.log(" Connecting to Mainnet Ethereum");

// const blockExplorer = targetNetwork.blockExplorer;

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  appendPosition: false,
  collapse: true,
  collapseDuration: 200,
  duration: 200,
});

function App() {
  const [theme, mounted] = useTheme();
  const location = useLocation();
  const [pathname, setPathname] = useState(location.pathname);

  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  let themeMode = lightTheme;

  const [show, setShow] = useState(false);

  return (
    <ThemeProvider theme={themeMode}>
      <CssBaseline />
      <Messages />
      <ToastContainer
        position="bottom-right"
        limit={1}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="light"
      />
      <Suspense fallback={<LoadingSplash />}>
        <Box display="flex" flexDirection="column" className={`app-container`}>
          <Header />
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/">
              <Redirect to="/" />
            </Route>
          </Switch>
          <Footer />
        </Box>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
